import { Box, Skeleton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';
import EmptyIcon from "../../../assets/images/empty-box.png";

// Custom shape renderer
const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  const fill = payload.color;

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999" style={{ fontSize: 14 }}>
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

const AuthenticationStatusComponent = (props) => {
  const { totalAuthenticationStatus, isFetchingAuthenticationStatus, breakpoints } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  console.log("totalAuthenticationStatus", totalAuthenticationStatus);

  // Default values for statuses
  const defaultValues = {
    Completed: 0,
    Pending: 0,
    Error: 0
  };

  // Determine if totalAuthenticationStatus is an array and has data
  const data = (Array.isArray(totalAuthenticationStatus) && totalAuthenticationStatus.length > 0)
    ? totalAuthenticationStatus.map(item => {
      const [name, value] = Object.entries(item)[0];
      let color;

      switch (name) {
        case 'Completed':
          color = '#40BF7E';
          break;
        case 'Pending':
          color = '#FFA500';
          break;
        case 'Error':
          color = '#E87867';
          break;
        case 'Success':
          color = '#40BF7E';
          break;
        default:
          color = '#8884d8';
      }

      return { name, value, color };
    })
    : Object.keys(defaultValues).map(name => ({
      name,
      value: defaultValues[name],
      color: name === 'Completed' ? '#40BF7E' : (name === 'Pending' ? '#FFA500' : '#E87867')
    }));

  const allZero = data.every(item => item.value === 0);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  return (
    <Box width="100%" height={300} display="flex" alignItems="center" justifyContent="center">
      {isFetchingAuthenticationStatus ? (
        <Skeleton variant="rectangular" width="100%" height={300} sx={{ backgroundColor: "rgb(108 139 222 / 30%)" }} />
      ) : (
        <>
          <ResponsiveContainer width="100%" height={300}>
            {allZero ? (
              <Box sx={{textAlign: "center", p: 1, pt: (breakpoints == "xs" || breakpoints == "sm") ? {} : "74px"}}>
                <img alt="empty-data-icon" src={EmptyIcon} width="140" />

                <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                  No data available for the selected date range
                </Typography>
              </Box>
            ) : (
              <PieChart>
                <Pie
                  activeIndex={activeIndex}
                  activeShape={renderActiveShape}
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={80}
                  outerRadius={100}
                  dataKey="value"
                  onMouseEnter={onPieEnter}
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            )}
          </ResponsiveContainer>
        </>
      )
      }
    </Box>

  );
};

export default AuthenticationStatusComponent;
